//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Formboard.js";
import "../no/Builder.js";
import "../no/Expression.js";
import "../no/Expression.js";
let d=[[[1,"NetlistLengthIncrement",0,"Expression",0],[0,"NetlistRoundingMethod",1,0],[1,"OverstockLengthIncrement",0,"Expression",0],[0,"OverstockRoundingMethod",1,0],[1,"SegmentLengthIncrement",0,"Expression",0],[0,"SegmentRoundingMethod",1,0]],[],[]];
SPLM.Formboard.LayoutLengthOptions = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Formboard.LayoutLengthOptions";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Formboard.LayoutLengthOptions.RoundingMethod = Object.freeze({
    "Exact" : "Exact", "Nearest" : "Nearest", "UpToNearest" : "UpToNearest", "DownToNearest" : "DownToNearest"});

export default SPLM;